import { patientModalAction } from "./patientModalAction";
import { patientRPMAction } from "./patientRPMAction";
import { patientTableAction } from "./patientTableAction";

export const patientAction = {
  ...patientRPMAction,
  ...patientTableAction,
  ...patientModalAction,
};
